import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getTablesOverviewRequest = (token) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl + "dashboard/gettablesoverview?organizationId=" + organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getDailyTurnOverRequest = (token, startDate, endDate) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "dashboard/dailyturnover?organizationId=" +
    organizationId +
    `&startDate=${startDate}&endDate=${endDate}`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getDailyTurnoverForPast8DaysByRestaurantsRequest = (token) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "dashboard/DailyTurnoverForPast8DaysByRestaurants?organizationId=" +
    organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export {
  getTablesOverviewRequest,
  getDailyTurnOverRequest,
  getDailyTurnoverForPast8DaysByRestaurantsRequest,
};
